<template>
</template>

<script>
export default {
	  mounted(){
		setTimeout(()=>{
			this.$router.push("/login");
		},200)
	}
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/default.vue